import { Component, type ReactNode } from 'react';

interface WorkspaceBoundaryProps {
  children: ReactNode;
}

interface WorkspaceBoundaryState {
  error: Error | null;
}

export class WorkspaceBoundary extends Component<WorkspaceBoundaryProps, WorkspaceBoundaryState> {
  state: WorkspaceBoundaryState = { error: null };

  static getDerivedStateFromError(error: unknown): WorkspaceBoundaryState {
    return { error: error instanceof Error ? error : new Error(String(error)) };
  }

  render() {
    if (this.state.error === null) return this.props.children;
    return (
      <div role="alert" className="flex h-full items-center justify-center p-6">
        <div className="max-w-md rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-200">
          <p className="font-semibold text-red-100">The preview failed to load.</p>
          <p className="mt-1 break-words font-mono text-xs text-red-300/90">{this.state.error.message}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-3 rounded-md border border-red-400/40 bg-red-500/15 px-3 py-1.5 text-xs font-semibold text-red-100 transition hover:bg-red-500/25"
          >
            Reload the page
          </button>
        </div>
      </div>
    );
  }
}
